import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";

@Injectable()
export class HasApplicationRoleGuard  {
  constructor(private authService: AuthenticationService, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let hasRoles = (await this.authService.getLatestRolesAndPermissionsAsync()).hasApplicationRole();
    if(!hasRoles) this.router.navigate(['/no-access'])
    return hasRoles;
  }
}